import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Villa = lazy(() => import("@/pages/elavtal/Villa"));

export const Route = createFileRoute("/elavtal/villa")({
  head: () => seoHead("/elavtal/villa"),
  component: () => <Villa />,
});
